import { useTranslation } from 'react-i18next';
import { fileExt } from '@immoaktas/shared';
import { Spinner } from '../ui';

const GROUP: Record<string, 'pdf' | 'word' | 'sheet' | 'image' | 'text'> = { pdf: 'pdf', docx: 'word', odt: 'word', rtf: 'word', xlsx: 'sheet', ods: 'sheet', csv: 'sheet', tsv: 'sheet', jpg: 'image', jpeg: 'image', png: 'image', webp: 'image', gif: 'image' };
const size = (b: number) => (b >= 1024 * 1024 ? `${(b / 1024 / 1024).toFixed(1).replace('.', ',')} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);

/**
 * A file in the chat, like in the chat with Claude: type badge, name (cut with an ellipsis, full name as tooltip),
 * size, page count or the current step, and a remove button while it is only attached.
 */
export function FileChip({ name, sizeBytes, pages, phase, error, onRemove }: { name: string; sizeBytes: number; pages?: number | null; phase?: 'uploading' | 'failed'; error?: string | null; onRemove?: () => void }) {
  const { t } = useTranslation();
  const ext = fileExt(name);
  const meta = error ?? (phase === 'uploading' ? t('agent.file.uploading') : phase === 'failed' ? t('agent.file.failed') : [size(sizeBytes), pages ? t('agent.file.pages', { count: pages }) : null].filter(Boolean).join(' · '));
  return (
    <div className={`agent-chip${error || phase === 'failed' ? ' error' : ''}`} title={name}>
      <span className={`agent-chip-icon ${GROUP[ext] ?? 'text'}`} aria-hidden>{ext.slice(0, 4).toUpperCase() || '?'}</span>
      <span className="agent-chip-body">
        <span className="agent-chip-name">{name}</span>
        <span className="agent-chip-meta">
          {phase === 'uploading' && <Spinner size={11} />}
          <span>{meta}</span>
        </span>
      </span>
      {onRemove && (
        <button type="button" className="agent-chip-x" aria-label={t('agent.remove', { name })} title={t('agent.remove', { name })} onClick={onRemove}>
          <span aria-hidden>×</span>
        </button>
      )}
    </div>
  );
}
